import React, { useEffect } from 'react'
import { Route, Redirect, useLocation } from 'react-router-dom'
import { useAuth, useModalRoutes, useErrorHandler } from 'hooks'
import { Box } from 'elements'
import NavBar from 'components/app/NavBar'
import RequireAuth from 'components/router/RequireAuth'
import RequireOrg from 'components/router/RequireOrg'
import RequireCompany from 'components/router/RequireCompany'
import IndexRedirect from 'components/router/IndexRedirect'
import CustomSwitch from 'components/router/CustomSwitch'
import Notifications from 'components/app/Notifications'
import UserNotifications from 'components/app/UserNotifications'
import {
  RootPage,
  AuthPage,
  ReportsPage,
  ReportPage,
  CompaniesPage,
  CompanyPage,
  IntegrationsPage,
  SettingsPage,
  TemplatesPage,
} from 'pages'
import IntegrationsWatcher from 'components/integrations/IntegrationsWatcher'

export default function App() {
  useErrorHandler()
  useModalRoutes()
  const { isLoggedIn, setCurrentCompany } = useAuth()
  let location = useLocation()

  // When the location changes, if the route isn't company specific, unset the current company
  useEffect(() => {
    if (location && location.pathname && !location.pathname.includes('/companies/')) {
      setCurrentCompany(null)
    }
  }, [location, setCurrentCompany])

  return (
    <Box height="100vh">
      <CustomSwitch>
        <Route exact path="/">
          <RootPage />
        </Route>
        <Route exact path="/login">
          <Redirect to="/auth/login" />
        </Route>
        <Route path="/auth">
          <AuthPage />
        </Route>

        <Route path="/orgs/:orgSlug">
          <IndexRedirect path="/orgs/:orgSlug" to="/companies" />
          <RequireAuth>
            <NavBar />
            <IntegrationsWatcher />

            <RequireOrg>
              <CustomSwitch>
                <Route path="/orgs/:orgSlug/settings">
                  <IndexRedirect path="/orgs/:orgSlug/settings" to="/members" />
                  <SettingsPage />
                </Route>
                <Route path="/orgs/:orgSlug/templates">
                  <TemplatesPage />
                </Route>
                <Route path="/orgs/:orgSlug/companies">
                  <CustomSwitch>
                    <Route exact path="/orgs/:orgSlug/companies">
                      <CompaniesPage />
                    </Route>
                    <Route path="/orgs/:orgSlug/companies/:companyId">
                      <IndexRedirect path="/orgs/:orgSlug/companies/:companyId" to="/reports" />
                      <RequireCompany>
                        <CustomSwitch>
                          <Route exact path="/orgs/:orgSlug/companies/:companyId/reports">
                            <ReportsPage />
                          </Route>
                          <Route path="/orgs/:orgSlug/companies/:companyId/reports/:reportId/:section?">
                            <ReportPage />
                          </Route>
                          <Route exact path="/orgs/:orgSlug/companies/:companyId/details">
                            <CompanyPage />
                          </Route>
                          <Route exact path="/orgs/:orgSlug/companies/:companyId/integrations">
                            <IntegrationsPage />
                          </Route>
                        </CustomSwitch>
                      </RequireCompany>
                    </Route>
                  </CustomSwitch>
                </Route>
              </CustomSwitch>
            </RequireOrg>
          </RequireAuth>
        </Route>
      </CustomSwitch>
      <Notifications />
      {isLoggedIn ? <UserNotifications /> : null}
    </Box>
  )
}
